/* BUFFLOW – Sözleşme onay kutusu ve bülten izni
 * Sepet sayfası (#main-cart-footer) ve sepet çekmecesinde (cart-drawer) "Ödeme"
 * butonunun üstüne zorunlu onay kutusu ekler. Onay, sepete özellik olarak yazılır
 * ve siparişte görünür. Ayrıca bülten formlarına ticari ileti izni kutusunu
 * ve KVKK bağlantısını ekler. */
(function () {
  if (window.__bufflowOnay) return;
  window.__bufflowOnay = true;

  var KEY = 'bufflow_sozlesme_onay';
  var ATTR = 'Ön Bilgilendirme ve Mesafeli Satış Onayı';
  var pending = null;
  var uid = 0;

  var css = '' +
    '.sz-onay{margin:0 0 1.4rem;text-align:left;font-size:1.3rem;line-height:1.5}' +
    '.sz-onay__label{display:flex;gap:1rem;align-items:flex-start;cursor:pointer}' +
    '.sz-onay__input{flex:none;width:1.8rem;height:1.8rem;margin:.2rem 0 0;accent-color:rgb(var(--color-foreground));cursor:pointer}' +
    '.sz-onay a{color:inherit;text-decoration:underline;text-underline-offset:.3rem}' +
    '.sz-onay__note{margin:.6rem 0 0 2.8rem;font-size:1.2rem;opacity:.75}' +
    '.sz-onay__error{margin:.6rem 0 0 2.8rem;color:#c0392b;font-weight:600}' +
    '.sz-onay.is-invalid .sz-onay__input{outline:2px solid #c0392b;outline-offset:2px}' +
    '.cart__dynamic-checkout-buttons{display:none!important}' +
    '.sz-bulten{margin:1rem 0 0;font-size:1.2rem;line-height:1.5;text-align:left}' +
    '.sz-bulten label{display:flex;gap:.8rem;align-items:flex-start;cursor:pointer}' +
    '.sz-bulten input{flex:none;width:1.6rem;height:1.6rem;margin:.2rem 0 0;cursor:pointer}' +
    '.sz-bulten a{color:inherit;text-decoration:underline}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function getState() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setState(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }

  function buildBox() {
    var id = 'SzOnay-' + (++uid);
    var w = document.createElement('div');
    w.className = 'sz-onay';
    w.setAttribute('data-sz-onay', '');
    w.innerHTML =
      '<label class="sz-onay__label" for="' + id + '">' +
        '<input type="checkbox" id="' + id + '" class="sz-onay__input" data-sz-onay-input aria-describedby="' + id + '-err">' +
        '<span><a href="/pages/on-bilgilendirme-formu" target="_blank" rel="noopener">Ön Bilgilendirme Formu</a>’nu ve ' +
        '<a href="/pages/mesafeli-satis-sozlesmesi" target="_blank" rel="noopener">Mesafeli Satış Sözleşmesi</a>’ni okudum, onaylıyorum.</span>' +
      '</label>' +
      '<p class="sz-onay__note">Kişisel verileriniz <a href="/pages/kvkk-aydinlatma-metni" target="_blank" rel="noopener">KVKK Aydınlatma Metni</a> kapsamında işlenir.</p>' +
      '<p class="sz-onay__error" id="' + id + '-err" role="alert" hidden>Devam etmek için sözleşmeleri onaylamanız gerekiyor.</p>';
    w.querySelector('input').checked = getState();
    return w;
  }

  function buildBulten() {
    var id = 'SzBulten-' + (++uid);
    var w = document.createElement('div');
    w.className = 'sz-bulten';
    w.innerHTML =
      '<label for="' + id + '"><input type="checkbox" id="' + id + '" required>' +
      '<span>BUFFLOW’dan e-posta ile kampanya, indirim ve yeni ürün duyuruları almak istiyorum. ' +
      'İstediğim zaman iletilerdeki bağlantıyla ücretsiz vazgeçebilirim. ' +
      '<a href="/pages/kvkk-aydinlatma-metni" target="_blank" rel="noopener">KVKK Aydınlatma Metni</a></span></label>';
    return w;
  }

  function inject() {
    document.querySelectorAll('#main-cart-footer .cart__ctas, cart-drawer .cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.hasAttribute('data-sz-onay')) return;
      ctas.parentNode.insertBefore(buildBox(), ctas);
    });
    document.querySelectorAll('form input[name="contact[tags]"][value*="newsletter"]').forEach(function (tag) {
      var form = tag.form;
      if (!form || form.querySelector('.sz-bulten')) return;
      form.appendChild(buildBulten());
    });
  }

  function syncAll() {
    var on = getState();
    document.querySelectorAll('[data-sz-onay-input]').forEach(function (i) { i.checked = on; });
    if (on) document.querySelectorAll('[data-sz-onay]').forEach(hideError);
  }
  function showError(w) {
    if (!w) return;
    w.classList.add('is-invalid');
    var e = w.querySelector('.sz-onay__error'); if (e) e.hidden = false;
    var i = w.querySelector('[data-sz-onay-input]'); if (i) i.focus();
  }
  function hideError(w) {
    w.classList.remove('is-invalid');
    var e = w.querySelector('.sz-onay__error'); if (e) e.hidden = true;
  }
  function saveAttribute(on) {
    var attrs = {}; attrs[ATTR] = on ? ('Onaylandı - ' + new Date().toISOString()) : '';
    pending = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {}).then(function () { pending = null; });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sz-onay-input]')) return;
    setState(e.target.checked);
    saveAttribute(e.target.checked);
    syncAll();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    if (btn.dataset.szBypass === '1') { delete btn.dataset.szBypass; return; }
    var scope = btn.closest('cart-drawer') || document.getElementById('main-cart-footer') || document;
    var wrap = scope.querySelector('[data-sz-onay]') || document.querySelector('[data-sz-onay]');
    if (!getState()) {
      e.preventDefault(); e.stopImmediatePropagation();
      showError(wrap);
      return;
    }
    if (pending) {
      e.preventDefault(); e.stopImmediatePropagation();
      pending.then(function () { btn.dataset.szBypass = '1'; btn.click(); });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout' && !getState()) {
      e.preventDefault();
      showError(document.querySelector('[data-sz-onay]'));
    }
  }, true);

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; inject(); syncAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  inject(); syncAll();
})();
